// Remove "__typename" fields from GraphQL objects
/* eslint-disable @typescript-eslint/no-explicit-any */
const removeTypename: any = (data: Record<string, unknown>) => {
  if (Array.isArray(data)) {
    return data.map(removeTypename);
  } else if (data && typeof data === 'object') {
    const cleanData: Record<string, unknown> = {};

    Object.keys(data).forEach((key) => {
      if (key !== '__typename') {
        cleanData[key] = removeTypename(data[key]);
      }
    });

    return cleanData;
  }

  return data;
};

export default removeTypename;
